const theme = {
  fontName: 'Helvetica Now Display',

  toast: {
    error: {
      iconTheme: { primary: 'red', secondary: 'white' },
      style: {
        color: '#ffffff',
        fontSize: '1.6rem',
        lineHeight: '120%',
        background: '#141414',
        borderRadius: '4rem'
      }
    },
    success: {
      iconTheme: { primary: 'green', secondary: 'white' },
      style: {
        color: '#ffffff',
        fontSize: '1.6rem',
        lineHeight: '120%',
        background: '#141414',
        borderRadius: '4rem'
      }
    }
  },

  button: {
    loadingType: 'text',
    primary: {
      height: '4.6rem',
      background: '#000000',
      border: 'none',
      borderRadius: '4px',
      boxShadow: 'none',
      color: '#ffffff',
      fontSize: '1.4rem',
      fontWeight: '500',
      iconColor: '#ffffff',
      iconSpacing: '1.4rem',
      padding: '0 2rem',

      hoverBackground: 'rgba(0, 0, 0, 0.9)',
      hoverBorder: 'none',
      hoverBoxShadow: 'none',
      hoverColor: '#ffffff',

      disabledColor: 'rgba(255, 255, 255, 0.25)',
      disabledBackground: '#1a1a1a',
      disabledBorder: 'none',
      disabledBoxShadow: 'none'
    },
    secondary: {
      height: '4.6rem',
      background: '#e8e8e8',
      border: '1px solid transparent',
      borderRadius: '4px',
      boxShadow: 'none',
      color: '#000000',
      fontSize: '1.4rem',
      fontWeight: '500',
      iconColor: '#000000',
      iconSpacing: '1.4rem',
      padding: '0 2rem',

      hoverBackground: '#dedede',
      hoverBorder: '1px solid transparent',
      hoverBoxShadow: 'none',
      hoverColor: '#000000',

      disabledColor: 'rgba(0, 0, 0, 0.25)',
      disabledBackground: '#ffffff',
      disabledBorder: '1px solid transparent',
      disabledBoxShadow: 'none'
    },
    alternative: {
      height: '4.6rem',
      background: '#ffffff',
      border: '1px solid transparent',
      borderRadius: '4px',
      boxShadow: 'none',
      color: '#000000',
      fontSize: '1.4rem',
      fontWeight: '500',
      iconColor: '#000000',
      iconSpacing: '1.4rem',
      padding: '0 2rem',

      hoverBackground: 'rgba(255, 255, 255, 0.8)',
      hoverBoxShadow: 'none',
      hoverColor: '#000000',

      disabledColor: 'rgba(0, 0, 0, 0.25)',
      disabledBackground: '#ffffff',
      disabledBorder: '1px solid transparent',
      disabledBoxShadow: 'none'
    },
    'round-primary': {
      height: '4rem',
      background: '#ffffff',
      border: 'none',
      borderRadius: '4.3rem',
      boxShadow: '0 1px 10px rgba(0, 0, 0, 0.08)',
      color: '#333333',
      fontSize: '1.4rem',
      fontWeight: '500',
      iconColor: '#333333',
      iconHeight: '1.4rem',
      iconSpacing: '6px',
      padding: '0 2rem',

      hoverBackground: '#dfdce3',
      hoverBoxShadow: '0 2px 15px rgba(0, 0, 0, 0.15)',
      hoverColor: '#000000',

      disabledColor: '#828282',
      disabledBackground: '#333333',
      disabledBorder: 'none',
      disabledBoxShadow: 'none'
    },
    'round-secondary': {
      height: '4rem',
      background: '#1a1a1a',
      border: '1px solid #808080',
      borderRadius: '4.3rem',
      boxShadow: 'none',
      color: '#808080',
      fontSize: '1.4rem',
      fontWeight: '500',
      iconColor: '#808080',
      iconHeight: '1.4rem',
      iconSpacing: '6px',
      padding: '0 2rem',

      hoverBackground: '#1a1a1a',
      hoverBorder: '1px solid #808080',
      hoverBoxShadow: 'none',
      hoverColor: '#ffffff',

      disabledColor: '#828282',
      disabledBackground: '#333333',
      disabledBorder: 'none',
      disabledBoxShadow: 'none'
    },
    delete: {
      height: '4rem',
      background: '#ff0431',
      border: 'none',
      borderRadius: '4.3rem',
      boxShadow: 'none',
      color: '#ffffff',
      fontSize: '1.4rem',
      fontWeight: '500',
      iconColor: '#ffffff',
      iconHeight: '1.4rem',
      iconSpacing: '6px',
      padding: '0 2rem',

      hoverBackground: '#ff0431',
      hoverBorder: 'none',
      hoverBoxShadow: 'none',
      hoverColor: '#ffffff',

      disabledColor: '#828282',
      disabledBackground: '#333333',
      disabledBorder: 'none',
      disabledBoxShadow: 'none'
    }
  },

  checkbox: {
    checkedIconBackgroundColor: '#ffffff',
    checkedIconBorderColor: '#ffffff',
    checkedIconBackgroundColorAlternative: '#000000',
    checkedIconBorderColorAlternative: '#000000',
    iconBackground: 'transparent',
    iconBorder: '1px solid #4f4f4f',
    iconBorderRadius: '2px',
    iconSize: '13px',
    fontSize: '1.6rem',
    fontStyle: 'normal',
    fontWeight: '500',
    textColor: '#828282'
  },

  dataTable: {
    body: {
      backgroundColor: 'transparent',
      border: '1px solid #282828',
      borderColor: '#828282',
      textColor: '#ffffff',
      fontSize: '1.6rem',
      fontWeight: 'normal',
      dropShadow: 'none',
      infoLineColor: '#939ea7'
    },
    head: {
      background: 'transparent',
      border: 'none',
      textColor: '#828282',
      fontSize: '1.6rem',
      fontWeight: '500'
    },
    hover: {
      backgroundColor: '#1a1a1a',
      border: '1px solid transparent',
      textColor: '#ffffff'
    }
  },

  dropTarget: {
    background: 'rgba(0, 0, 0, 0.8)',
    border: '2px solid #828282',
    borderRadius: '2rem',
    textColor: '#ffffff',
    fontSize: '1.6rem',
    fontWeight: 'normal'
  },

  gridTable: {
    border: '1px solid #828282',
    fontSize: '1.4rem',
    fontSize2: '1.6rem',
    fontWeight: '500',
    lineHeight: '1.7rem',
    lineHeight2: '2rem',
    labelColor: '#828282',
    valueColor: '#dfdce3',
    negativeColor: '#ee2b2b',
    positiveColor: '#59b300',
    rowPadding: '1rem 0',
    totalFontSize: '2rem',
    totalFontSize2: '2.4rem',
    totalFontWeight: 'bold',
    totalLineHeight: '2.4rem',
    totalLineHeight2: '3rem'
  },

  input: {
    label: {
      textColor: '#afafaf',
      fontSize: '1.2rem',
      fontWeight: '400',
      lineHeight: '120%',
      textTransform: 'none',
      marginBottom: '5px',
      marginLeft: '2rem',
      asteriskColor: '#afafaf',
      asteriskMargin: '0',
      asteriskPosition: 'right',
      paddingWithIcon: '0',
      paddingRequired: '0'
    },
    error: {
      textColor: '#ff0431',
      padding: '0 2.4rem',
      marginTop: '5px'
    },
    wrapper: {
      marginBottom: '3rem'
    },
    container: {
      textColor: '#000000',
      fontSize: '1.4rem',
      fontWeight: '400',
      lineHeight: '140%',
      background: 'transparent',
      border: '1px solid #808080',
      borderWidth: '1px',
      borderRadius: '2.5rem',
      padding: '0 2rem',
      iconColor: '#ffffff',
      errorBorderColor: '#ff0431',
      errorBorderWidth: '1px',
      focusedBorderColor: '#808080',
      focusedBorderWidth: '1px'
    },
    placeholder: {
      textColor: '#808080',
      fontSize: '1.4rem',
      fontWeight: '400',
      lineHeight: '140%'
    },
    dropDown: {
      controlBorder: '1px solid #808080',
      controlBorderRadius: '4.2rem',
      controlPadding: '0 1rem 0 2rem',
      indicatorColor: '#808080',
      menuBackground: '#ffffff',
      menuBorder: 'none',
      menuBorderRadius: '0 0 2.5rem 2.5rem',
      menuMargin: '0',
      menuPadding: '1rem',
      openedBackground: '#ffffff',
      openedBorder: 'none',
      openedBorderRadius: '2.5rem 2.5rem 0 0',
      openedColor: '#000000',
      optionBorderRadius: '1rem',
      optionColor: '#000000',
      optionFontSize: '1.4rem',
      optionFontWeight: '400',
      optionLineHeight: '140%',
      optionMargin: '2px 0 0',
      optionPadding: '1rem',
      optionBackground: 'transparent',
      focusedOptionColor: '#ffffff',
      focusedOptionBackground: '#1a1a1a',
      buttonColor: '#ffffff',
      buttonTextAlign: 'center',
      buttonBorderRadius: '2rem',
      buttonBackground: '#1a1a1a',
      buttonMargin: '0 auto',
      buttonWidth: '90%'
    },
    settings: {
      height: '4rem',
      singleSelect: true,
      autofillBackground: '#404040',
      dropDownArrowColor: '#ffffff',
      textareaMargin: '1.3rem 0 1.5rem',
      textareaPadding: '0',
      hideLabelWhenEmpty: false,
      showPasswordWithText: false
    }
  },

  progressBar: {
    background: 'rgba(79, 79, 79, 1)',
    colorGreen: 'rgba(0, 180, 81, 1)',
    colorRed: 'rgba(232, 17, 45, 1)'
  },

  pagination: {
    marginPages: 1,
    minPagesVisible: 2,
    noArrowButtons: false,
    showPageLabel: false,
    fontSize: '1.4rem',
    fontWeight: '600',
    lineHeight: '1.7rem',
    textColor: '#ffffff',
    backgroundColor: '#202020',
    buttonBorderColor: 'transparent',
    buttonRadius: '0',
    buttonMargin: '0',
    buttonSize: '4rem',
    buttonTextColor: '#4f4f4f',
    buttonHoverBorderColor: 'transparent',
    buttonHoverTextColor: '#ffffff',
    buttonActiveBackground: '#202020',
    buttonActiveBorderRadius: '0',
    buttonActiveBoxShadow: 'none',
    buttonActiveTextColor: '#ffffff'
  },

  radioButton: {
    iconSize: '2rem',
    iconSpacing: '1rem',
    fontSize: '1.4rem',
    fontStyle: 'normal',
    fontWeight: '400',
    lineHeight: '120%',
    textColor: '#ffffff',
    loadingColor: '#828282',
    loadingSize: '30'
  },

  //todo checkout

  checkoutHeader: {
    height: '12rem'
  },
  checkoutContainer: {
    width: '45rem',
    marginBottom: '3rem'
  },
  paymentContainer: {
    background: '#ffffff',
    backdropFilter: 'blur(44px)',
    borderRadius: '7px',
    boxShadow: 'none',

    minHeight: '20rem',
    marginTop: '2rem',
    padding: '3rem 3rem 4rem',

    inputMargin: '0',
    buttonHeight: '5.3rem',
    buttonFontSize: '2.2rem',
    buttonFontWeight: '500',
    buttonLineHeight: 'normal'
  },

  warningMessage: {
    background: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 0 25px rgba(46, 53, 56, 0.1)',

    color: '#000000',
    fontSize: '1.2rem',
    fontWeight: '400',
    lineHeight: '1.5rem',

    noteMargin: '0 0 1.5rem',

    title: {
      marginBottom: '2rem',
      textAlign: 'center',

      color: '#000000',
      fontSize: '1.6rem',
      fontWeight: '600',
      lineHeight: '2rem',

      iconMargin: '1rem'
    }
  },

  errorText: {
    marginTop: '20rem',
    headAlignment: 'center',
    headColor: '#ffffff',
    headFontSize: '6.4rem',
    textAlignment: 'center',
    textColor: '#ffffff',
    textFontSize: '1.8rem',
    textMargin: '3rem'
  },

  messageWrapper: {
    success: {
      background: '#00ff66',
      backdropFilter: 'blur(44px)'
    },
    failure: {
      background: '#ff0431',
      backdropFilter: 'blur(44px)'
    }
  },

  merchantPane: {
    background: 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(44px)',
    borderRadius: '7px',
    textColor: '#ffffff',
    left: {
      background: 'transparent',
      padding: '3rem 3rem 2.5rem',
      color: '#ffffff',
      fontSize: '3.6rem',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '100%',
      amountFontSize: '3.6rem',
      amountFontWeight: 'normal',
      amountLineHeight: '100%',
      amountMargin: '2rem'
    },
    right: {
      background: 'rgba(0, 0, 0, 0.25)',
      padding: '1.4rem 3rem 3rem',
      fontSize: '1.8rem',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '100%',
      labelColor: '#808080',
      labelFontSize: '1.3rem',
      labelLineHeight: '100%',
      labelTransform: 'none',
      labelMargin: '0.5rem',
      rowMargin: '2rem'
    }
  }
}

export default theme
